import React from "react";

const ChciNaZus = () => {
  return (
    <div>
      <h1>Chci na Zuš!</h1>
      <p>nevimmm</p>
    </div>
  );
};

export default ChciNaZus;